import { useDispatch, useSelector } from "react-redux";
import Modal from "../../UI/Modal";
import { closeAccionMultiplesModal } from "../../../store/reducers/fortalezas/fortalezasPlantel.reducer";
import { useState } from "react";
import { createMultiplesAccionesPlantelThunk, getAccionesDesarrolloPlantelThunk } from "../../../store/reducers/fortalezas/fortalezasPlantel.thunks";
import Loader from "../../UI/Loader";
import Alert from "../../UI/Alert";
import Select2 from "../../UI/Select2";
import { getAreasSelectoresPlantelService } from "../../../services/fortalezas/fortalezasPlantel.service";
import { getTalentosSelectoresPlantelService } from "../../../services/planteles/talentosPlantel.service";
import { toast } from "react-toastify";
import { Icon } from "@iconify/react";
import { useParams } from "react-router-dom";

const AccionMultiplesModalPlantel = () => {
  const dispatch = useDispatch();
  const { plantelId } = useParams();
  const { accionMultiplesModalOpen, accionMultiplesLoading, accionMultiplesError } = useSelector((state) => state.fortalezasPlantel);

  const [area, setArea] = useState(null);
  const [talento, setTalento] = useState(null);
  const [frases, setFrases] = useState([""]);

  const fetchAreas = async (searchTerm) => {
    const response = await getAreasSelectoresPlantelService(plantelId, searchTerm);
    return response.map((item) => ({ id: item.id, label: item.label || item.area }));
  };

  const fetchTalentos = async (searchTerm) => {
    const response = await getTalentosSelectoresPlantelService(plantelId, searchTerm);
    return response.map((item) => ({ id: item.id, label: item.label }));
  };

  const handleClose = () => { dispatch(closeAccionMultiplesModal()); setArea(null); setTalento(null); setFrases([""]); };

  const addFrase = () => setFrases((prev) => [...prev, ""]);
  const removeFrase = (index) => setFrases((prev) => prev.filter((_, i) => i !== index));
  const handleFraseChange = (index, value) => setFrases((prev) => prev.map((f, i) => (i === index ? value : f)));
  const frasesValidas = frases.filter((f) => f.trim() !== "");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!area) { toast.error("Debes seleccionar un área"); return; }
    if (!talento) { toast.error("Debes seleccionar un talento"); return; }
    if (frasesValidas.length === 0) { toast.error("Debes agregar al menos una frase"); return; }

    const payload = { area, talento, frases: frasesValidas.map((f) => ({ frase: f })), is_active: true };
    const result = await dispatch(createMultiplesAccionesPlantelThunk(payload));
    if (result.meta.requestStatus === "fulfilled") {
      dispatch(getAccionesDesarrolloPlantelThunk({ plantelId, page: 1, search: "", area: "", talento: "" }));
      toast.success(`${frasesValidas.length} acción(es) creada(s) exitosamente`);
      handleClose();
    }
  };

  return (
    <Modal open={accionMultiplesModalOpen} onClose={handleClose} title="Crear múltiples acciones" size="lg">
      {accionMultiplesLoading ? <Loader center type="dots" text="Creando acciones..." /> : (
        <form onSubmit={handleSubmit}>
          {accionMultiplesError && <Alert message={accionMultiplesError} variant="error" />}
          <div className="row mb-3">
            <div className="col-md-6 mb-3 mb-md-0">
              <label className="form-label fw-medium">Área de desarrollo <span className="text-danger">*</span></label>
              <Select2 value={area} onChange={(v) => setArea(v || null)} fetchOptions={fetchAreas} placeholder="Selecciona un área..." />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-medium">Talento <span className="text-danger">*</span></label>
              <Select2 value={talento} onChange={(v) => setTalento(v || null)} fetchOptions={fetchTalentos} placeholder="Selecciona un talento..." />
            </div>
          </div>
          <div className="mb-3">
            <label className="form-label fw-medium">Frases / Acciones <span className="text-danger">*</span></label>
            <div className="d-flex flex-column gap-2">
              {frases.map((frase, index) => (
                <div key={index} className="d-flex gap-2 align-items-start">
                  <textarea className="form-control" value={frase} onChange={(e) => handleFraseChange(index, e.target.value)} placeholder={`Frase ${index + 1}`} rows="2" />
                  {frases.length > 1 && <button type="button" className="btn btn-outline-danger btn-sm d-flex align-items-center justify-content-center" style={{ minWidth: "38px", height: "38px" }} onClick={() => removeFrase(index)}><Icon icon="mdi:close" width="18" /></button>}
                </div>
              ))}
            </div>
            <button type="button" className="btn btn-sm btn-outline-primary mt-2 d-flex align-items-center gap-1" onClick={addFrase}><Icon icon="mdi:plus" width="16" /> Agregar otra frase</button>
          </div>
          <div className="d-flex justify-content-end gap-2 mt-3">
            <button type="button" className="btn btn-secondary" onClick={handleClose}>Cancelar</button>
            <button type="submit" className="btn btn-primary">Crear {frasesValidas.length > 0 ? `(${frasesValidas.length})` : ""}</button>
          </div>
        </form>
      )}
    </Modal>
  );
};

export default AccionMultiplesModalPlantel;
